import React, { ReactElement, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal } from 'react-responsive-modal';
import {
    DOWNLOAD_CSV_ALL_REGISTRATION,
    DOWNLOAD_CSV_COMPANY_REGISTRATION,
    DOWNLOAD_CSV_INSTITUTE_REGISTRATION,
} from '../../redux/rootActions';
import { RootState } from '../../redux/rootReducer';

interface Props {
    modalVisible: boolean;
    setModalVisible: (value: boolean) => void;
    message?: string;
    setMessage?: (value: string) => void;
}

export default function CSVEmailedSuccessModal({
    modalVisible,
    setModalVisible,
}: Props): ReactElement {
    const dispatch = useDispatch();

    const allRegisterCSVMessage = useSelector(
        (state: RootState) => state.dashboard.allRegisterCSVMessage
    );

    const instituteRegisterCSVMessage = useSelector(
        (state: RootState) => state.dashboard.instituteRegisterCSVMessage
    );

    const companyRegisterCSVMessage = useSelector(
        (state: RootState) => state.dashboard.companyRegisterCSVMessage
    );

    // useEffect(() => {
    //     if (allRegisterCSVMessage) {
    //         dispatch({ type: DOWNLOAD_CSV_ALL_REGISTRATION });
    //     }

    //     if (instituteRegisterCSVMessage) {
    //         dispatch({ type: DOWNLOAD_CSV_INSTITUTE_REGISTRATION });
    //     }

    //     if (companyRegisterCSVMessage) {
    //         dispatch({ type: DOWNLOAD_CSV_COMPANY_REGISTRATION });
    //     }
    // }, [companyRegisterCSVMessage, instituteRegisterCSVMessage, allRegisterCSVMessage]);
    return (
        <Modal
            open={modalVisible}
            onClose={() => {
                setModalVisible(false);
            }}
            center
            showCloseIcon={false}
            styles={{
                modal: {
                    borderRadius: 5,
                    maxWidth: '628px',
                    borderStyle: 'solid',
                    borderWidth: '2px',
                    boxShadow: '0 12px 15px 0 rgb(0 0 0 / 10%)',
                },
                overlay: { background: 'none' },
            }}
        >
            <div className="">
                <div className="text-base text-center text-gray-800 px-4 pt-6 pb-4">
                    The CSV has been sent to the email of the user.
                </div>
                <div className="flex justify-end w-full">
                    <button
                        className="bg-blue-700 text-white rounded-sm focus:outline-none mt-4 px-8 mr-2 md:mr-0 py-2"
                        onClick={() => {
                            setModalVisible(false);
                        }}
                    >
                        OK
                    </button>
                </div>
            </div>
        </Modal>
    );
}
